@import '../../../theme.scss';

verdocs-ok-dialog {
  box-sizing: border-box;
  font-family: $primary-font;

  &.closed {
    display: none;
  }

  .buttons {
    gap: 12px;
    display: flex;
    margin-top: 0;
    flex-direction: row;
    justify-content: flex-end;

    button {
      padding: 8px 16px;
      height: 40px;
      display: flex;
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
      align-items: center;
      border-radius: var(--verdocs-button-radius, 4px);
      justify-content: center;
      transition: all 0.2s ease;

      &.cancel {
        background-color: transparent;
        border: var(--verdocs-button-secondary-border, 1px solid #d1d5db);
        color: var(--verdocs-button-secondary-color, #374151);
      }

      &.ok {
        background-color: var(--verdocs-primary-color, $verdocs-green);
        border: 1px solid transparent;
        color: #ffffff;

        &:hover {
          background-color: var(--verdocs-primary-color-hover, $verdocs-green-shade);
        }
      }

      &:disabled {
        background-color: var(--verdocs-button-disabled-bg, #e5e7eb);
        color: var(--verdocs-button-disabled-color, #9ca3af);
        cursor: not-allowed;
      }
    }
  }
}
